"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberRole = void 0;
var MemberRole;
(function (MemberRole) {
    MemberRole["MEMBER"] = "member";
    MemberRole["MANAGER"] = "manager";
})(MemberRole = exports.MemberRole || (exports.MemberRole = {}));
